import { render, staticRenderFns } from "./Amount.vue?vue&type=template&id=3ba1e370&scoped=true"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"
import style0 from "./Amount.vue?vue&type=style&index=0&id=3ba1e370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1e370",
  null
  
)

export default component.exports